import elementLocale from 'element-ui/lib/locale/lang/fr';

export default {
  // Messages
  messages: {
    '{brand} ending in {last4}': '{brand} prendra fin dans {last4}',
    '{count} Pages Selected': 'Aucune page sélectionnée | 1 Page sélectionnée | {count} Pages sélectionnées',
    '{count} Pages': 'Aucune page | 1 Page | {count} Pages',
    '{user} published changes to {page} on {site}': '{user} a modifié la page {page} du site {site}',
    '{user} saved a draft of {page} on {site}': '{user} a enregistré un brouillon de la page {page} du site {site}',
    '100%': '100%',
    '25%': '25%',
    '50%': '50%',
    '75%': '75%',
    'A file already exists at the specified location.': 'Un fichier du même nom existe déjà à cet emplacement.',
    'Access Control List (ACL)': 'Liste de contrôle d\'accès (ACL)',
    'Access Key': 'Access Key',
    'Actions': 'Actions',
    'Add To Favorites': 'Ajouter aux favoris',
    'Additional Text': 'Information à faire apparaître',
    'Admin': 'Administration',
    'Advanced': 'Avancé',
    'Align Center': 'Centré',
    'Align Left': 'Aligné à gauche',
    'Align Right': 'Aligné à droite',
    'Alignment': 'Alignement',
    'All Images': 'Toutes les images',
    'All Pages': 'Toutes',
    'Allow this user to change the settings for this account.': "L'utilisateur pourra modifier les paramètres du compte.",
    'Allow this user to create, delete, and update sites.': 'Autorisez cet utilisateur à créer, supprimer et mettre à jour des sites Web.',
    'Allow this user to create, delete, and update users.': 'Autorisez cet utilisateur à créer, supprimer et mettre à jour des utilisateurs.',
    'Allow this user to view invoices and manage payment info.': "L'utilisateur pourra accéder aux factures et aux informations de paiement.",
    'Allow users to delete pages on this site.': 'Autoriser les utilisateurs à supprimer des pages de ce site Web.',
    'Allow users to duplicate pages on this site.': 'Autoriser les utilisateurs à dupliquer des pages sur ce site Web.',
    'Alternative text for users who can\'t see images.': "La description apparaît lorsqu'il y a un problème pour afficher l'image.",
    'Amount': 'Total',
    'An account has been created for you to manage your website. Please follow the link below to confirm your account.': 'Un compte a été créé pour vous par {adminName} afin que vous puissiez modifier votre site Internet en toute autonomie. Pour finaliser la création de votre compte veuillez cliquer sur le lien ci-dessous.',
    'An error occurred. Please try your request again later.': "Une erreur est survenue. Essayez de nouveau dans un petit moment s'il vous plait.",
    'An invitation will be sent to this email address when the user is created.': "Un e-mail d'invitation sera envoyé à cette adresse.",
    'Analytics': "Analyse d'audience",
    'Anchor': 'Ancre',
    'API Access': 'Accès API',
    'App Name': 'Nom du service',
    'Apply': 'Enregistrer',
    'Are you sure you want to delete {count} files?': "Il n'y a rien à supprimer ! | Êtes-vous sûr de vouloir supprimer ce fichier ? | Êtes-vous sûr de vouloir supprimer ces {count} fichiers ?",
    'Are you sure you want to do this?': 'Attention, cette action sera irréversible !',
    'Authentication': 'Authentification',
    'Average Time On Site': 'Temps moyen passé sur le site',
    'Back To Site': 'Retour au site',
    'Back': 'Retour',
    'Background': 'Arrière-plan',
    'Best Fit': 'Adapté',
    'Billing': 'Abonnement',
    'Bio': 'Biographie',
    'Blockquote': 'Citation',
    'Blocks cannot contain ID attributes.': 'Les attributs "id" ne sont pas autorisés dans les blocs.',
    'Blocks': 'Blocs',
    'Bold': 'Gras',
    'Bounce Rate': 'Taux de rebond',
    'Branding': 'Personnalisation',
    'Browse': 'Parcourir',
    'Browsers': 'Navigateurs',
    'Bucket': 'Groupe',
    'Bug Report': 'Anomalie/ Bug',
    'Bulleted List': 'Puces',
    'Can this question help other users?': "Votre question peut-elle servir à d'autres utilisateurs ?",
    'Cancel': 'Annuler',
    'Caption': 'Afficher les crédits',
    'Cell': 'Cellule',
    'Change Password': 'Modifier le mot de passe',
    'Change Profile Picture': 'Modifier la photo de profil',
    'Changing this will cause all active users to be logged out immediately. You are responsible for informing users of the new domain.': 'Cette modification engendrera la déconnexion de tous vos utilisateurs. Merci de les informer de la nouvelle adresse.',
    'Choose Image': 'Choisir une photo',
    'Cities': 'Villes',
    'Classification': 'Classification',
    'Cleanup Code': 'Nettoyer le code',
    'Client': 'Utilisateur',
    'Code Block': 'Extrait de code',
    'Code': 'Code',
    'Color': 'Couleur',
    'Column': 'Colone',
    'Commercial': 'Commercial',
    'Confirm My Account': 'Valider mon compte',
    'Congratulations! Two-factor authentication has been enabled for your account.': 'Toutes nos félicitations! L\'authentification à deux facteurs a été activée pour votre compte.',
    'Connect your Google Analytics account to enable the analytics dashboard for selected sites.': "Utilisez votre compte Google Analytics pour activer le tableau de bord de mesure d'audience des sites sélectionnés.",
    'Connecting...': 'Connexion…',
    'Connection successful!': 'Connecté !',
    'Content': 'Contenu',
    'Continents': 'Continents',
    'Continue Editing': 'Continuer',
    'Continue': 'Continuer',
    'Copy and paste the video\'s URL or embed code here.': "Copier et coller l'url de la vidéo ou le code embed ici.",
    'Countries': 'Pays',
    'Cover': 'Couverture',
    'Create Block': 'Valider',
    'Create Folder': 'Valider',
    'Create Page': 'Valider',
    'Create Site': 'Valider',
    'Create Template': 'Valider',
    'Create User': 'Valider',
    'Current Password': 'Mot de passe actuel',
    'Customize Invoices': 'Factures personnalisées',
    'Dark Logo': 'Logo sur fond sombre',
    'Dashboard': 'Dashboard',
    'Date': 'Date',
    'Decrease Indent': 'Diminuer le retrait',
    'Delete Anchor': "Supprimer l'ancre",
    'Delete Block': 'Supprimer',
    'Delete Code Block': 'Supprimer',
    'Delete Column': 'Supprimer la colone',
    'Delete Gallery': 'Supprimer la galerie',
    'Delete Image': "Supprimer l'image",
    'Delete My Account': 'Supprimer mon compte',
    'Delete Row': 'Supprimer la ligne',
    'Delete This Site': 'Supprimer ce site',
    'Delete This User': 'Supprimer cet utilisateur',
    'Delete Video': 'Supprimer la vidéo',
    'Delete': 'Supprimer',
    'Delete Pages': 'Supprimer des pages',
    'Demo Site': 'Site de démonstration',
    'Depth of Visit': 'Profondeur de visite',
    'Description': 'Description',
    'Devices': 'Appareils',
    'Did we make a mistake? Let us know!': 'Nous avons fait une erreur ? Dites-nous tout !',
    'Disable API Access': 'Désactiver l\'accès à l\'API',
    'Disable Line Wrapping': 'Ne pas renvoyer à la ligne',
    'Disable lockdown to make changes to this site.': 'Désactivez le verrouillage pour pouvoir modifier ce site.',
    'Disable Two-factor Authentication': 'Désactiver l\'authentification à deux facteurs',
    'Disable': 'Désactiver',
    'Documentation': 'Documentation',
    'Domain': 'Adresse personnalisée',
    'Done': 'Terminer',
    'Draft': 'Brouillon',
    'Drafts & Revisions': 'Brouillons & Versions',
    'Drag and drop an HTML file or copy and paste the full source of your block.': 'Déposez un fichier HTML ou collez ici le code source de votre bloc.',
    'Drag and drop an HTML file or copy and paste the full source of your page template.': 'Déposez un fichier HTML ou collez ici le code source de votre template.',
    'Duplicate ID': 'Duplicate ID',
    'Duplicate': 'Copier',
    'Duplicate Pages': 'Pages en double',
    'Edit Block': 'Modifier',
    'Edit Metadata': 'Métadonnées',
    'Edit Profile': 'Profil',
    'Edit Site': 'Paramètres du site',
    'Edit Source': 'Modifier le code source',
    'Edit Template': 'Modifier le template',
    'Edit User': 'Modifier',
    'Edit': 'Modifier',
    'Educational': 'Éducatif',
    'Email': 'E-mail',
    'Embed Code': 'Code embed',
    'Enable access to programmatically manage sites, users, and more.': 'Activez l\'accès pour gérer par programme les sites, les utilisateurs et plus encore.',
    'Enable access to the CMS from a white-label domain.': 'Activer le domaine personnalisé pour accéder au CMS.',
    'Enable API Access': 'Activer l\'accès à l\'API',
    'Enable Change Notifications': "M'avertir de toute modification",
    'Enable Line Wrapping': 'Renvoyer à la ligne',
    'Enable Lockdown': 'Verrouiller le site',
    'Enable Pages': 'Pages modifiables',
    'Enable Two-factor Authentication': 'Activer l\'authentification à deux facteurs',
    'Enable': 'Activer',
    'End Date': 'Date de fin',
    'Enter a brief description of this block.': 'Décrivez brièvement votre bloc.',
    'Enter a brief description of this template.': 'Décrivez brièvement votre template.',
    'Enter a caption for the selected photo.': 'Renseignez un crédit pour la photo sélectionnée.',
    'Enter a name for the new folder.': 'Saisissez le nom du nouveau dossier.',
    'Enter a name for your website.': 'Définissez le nom du site.',
    'Enter the code generated by your app': 'Saisissez le code généré par votre application',
    'Enter your website\'s URL.': "Saisissez l'adresse de votre site.",
    'Error': 'Erreur',
    'Exit Pages': 'Pages de sortie',
    'Failed to locate content region.': "Aucun contenu éditable n'a été trouvé.",
    'Favicon': 'Favicône',
    'Favorites': 'Favoris',
    'Feature Request': 'Fonctionnalité manquante',
    'File Extension': 'Extension',
    'Filename': 'Nom du fichier',
    'Files cannot be recovered once they are deleted.': 'Une fois supprimés les fichiers ne peuvent pas être récupérés.',
    'Files cannot be uploaded here.': "Impossible d'uploader un fichier ici.",
    'Files': 'Fichiers',
    'Finished With Errors': 'Terminé en erreur',
    'Finished': 'Terminé',
    'Folder': 'Dossier',
    'Forgot your password?': 'Mot de passe oublié ?',
    'Format': 'Mise en forme',
    'Gallery': 'Galerie',
    'General Support': 'Utilisation du CMS',
    'General': 'Général',
    'Get a helpful response in less than 24 hours, even on weekends and holidays.': 'Recevez une réponse en moins de 24 heures, même pendant les week-ends et les jours fériés.',
    'Give this user administrative privileges.': 'Donnez à cet utilisateur des privilèges administratifs.',
    'Give your clients a custom solution with your company\'s branding. Clients will see your business, your logo, and your custom domain.': "Proposez à vos clients une solution à l'image de votre société : le nom de votre choix, votre logo, votre adresse personnalisée,...",
    'Go to the settings page to enable this feature.': 'Activez cette fonctionnalité dans la rubrique Paramètres.',
    'Heading {num}': 'Titre {num}',
    'Highlight': 'Surligné',
    'Home Folder': 'Dossier racine',
    'Homepage': "Page d'accueil",
    'Host': 'Hôte',
    'I have stored my recovery code in a secure place': 'J\'ai stocké mon code de récupération dans un endroit sécurisé',
    'If set, clients will be sent to this URL instead of the standard support page.': 'Si vous renseignez une adresse vos utilisateurs y seront redirigés lorsqu\'il cliqueront sur le lien "Assistance".',
    'If so, consider posting it to the {forum} instead.': "Si oui, posez-la de préférence dans le {forum} s'il vous plait.",
    'If you didn\'t request this, you can safely ignore this message.': "Si vous ne l'avez pas demandé, vous pouvez ignorer ce message en toute sécurité.",
    'If your bucket has ACLs enabled, enable this option to give "public-read" permissions to uploaded files.': 'Si les ACL sont activées dans votre compartiment, activez cette option pour accorder des autorisations de « public-read » aux fichiers téléchargés.',
    'If your website doesn\'t use HTTPS, stylesheets and other mixed content will not load in the editor. Please consider securing your website with an SSL certificate.': "Votre site doit être sécurisé par un certificat SSL pour que les feuilles de styles et les autres contenus mixtes soient pris en compte dans l'éditeur.",
    'Image': 'Image',
    'Increase Indent': 'Augmenter le retrait',
    'Insert Anchor': 'Ajouter',
    'Insert Block': 'Ajouter',
    'Insert Code Block': 'Ajouter',
    'Insert Column After': 'Insérer une colone à droite',
    'Insert Column Before': 'Insérer une colone à gauche',
    'Insert Gallery': 'Ajouter',
    'Insert Image': 'Ajouter',
    'Insert Link': 'Ajouter',
    'Insert Row After': 'Insérer une ligne au-dessus',
    'Insert Row Before': 'Insérer une ligne en dessous',
    'Insert Table': 'Ajouter',
    'Insert Video': 'Ajouter',
    'Insert': 'Ajouter',
    'Invoice': 'Facture',
    'Italic': 'Italique',
    'Keyboard Shortcuts': 'Raccourcis clavier',
    'Keywords': 'Mots-clés',
    'Landing Pages': "Pages d'entrée",
    'Landscape': 'Format paysage',
    'Language': 'Langue',
    'Language[computer]': 'Langage',
    'Languages': 'Langues',
    'Last {days} days': 'Durant les {days} derniers jours',
    'Last seen {date}': 'Vu pour la dernière fois le {date}',
    'Last year': "L'année dernière",
    'Launch {appName}': 'Lancez {appName}',
    'Length of Visit': 'Durée de visite',
    'Light Logo': 'Logo sur fond clair',
    'Link': 'Lien',
    'Links to this page will stop working. You should only change the filename if you\'re sure nothing is linking to this page.': "Les liens vers cette page ne fonctionneront plus. Veuillez ne changer le nom du fichier que si vous êtes sûr qu'aucun lien ne pointe déjà dessus.",
    'Lists': 'Listes',
    'Load More': 'Afficher plus',
    'Loading...': 'Chargement…',
    'Login': 'Se connecter',
    'Logo': 'Logo',
    'Logos': 'Logos',
    'Logout': 'Déconnexion',
    'Lost your device?': 'Vous avez perdu votre appareil?',
    'Main': 'Menu',
    'Make Administrator': 'Administrateur',
    'Manage Billing': "Gestion de l'abonnement",
    'Manage Blocks': 'Gestion des blocs',
    'Manage Files': 'Gestion des fichiers',
    'Manage Pages': 'Gestion des pages',
    'Manage Settings': 'Gestion des paramètres',
    'Manage Sites': 'Gestion de site',
    'Manage Templates': 'Gestion des templates',
    'Manage Users': 'Gestion des utilisateurs',
    'Merge Cells': 'Fusionner les cellules',
    'Metadata': 'Métadonnées',
    'Missing ID': 'ID manquant',
    'Mobile Devices': 'Appareils mobiles',
    'Move Down': 'Déplacer vers le bas',
    'Move Up': 'Déplacer vers le haut',
    'My Account': 'Mon compte',
    'Name': 'Nom',
    'Need something else to appear on your invoice?': 'Besoin de faire apparaître des informations supplémentaires sur votre facture ?',
    'Never logged in': "Ne s'est jamais connecté",
    'New Block': 'Nouveau bloc',
    'New Folder': 'Nouveau dossier',
    'New Page': 'Nouvelle page',
    'New Password': 'Nouveau mot de passe',
    'New Site': 'Nouveau site',
    'New Template': 'Nouveau template',
    'New User': 'Nouvel utilisateur',
    'New Visits': 'Nouvelles visites',
    'No Blocks': 'Aucun bloc',
    'No Files': 'Aucun fichier',
    'No Images': 'Aucune image',
    'No Pages': 'Aucune page',
    'No Recent Activity': 'Aucune activité récente',
    'No Results': 'Aucun résultat',
    'No Revisions': 'Aucune version enregistrée',
    'No Sites': 'Aucun site',
    'No Templates': 'Aucun template',
    'Non-profit': 'Non lucratif',
    'None': 'Aucun',
    'Not Found': 'Non trouvé',
    'Now that you\'re connected, let\'s enable some pages!': 'Votre site est bien connecté, sélectionnons maintenant les pages à gérer !',
    'Now that you\'ve confirmed your account, you can manage your website any time using the link below.': 'Maintenant que vous avez confirmé votre compte, vous pouvez gérer votre site Web à tout moment en utilisant le lien ci-dessous.',
    'Numbered List': 'Numérotation',
    'Once your account is deleted, it cannot be recovered!': 'Attention, si vous supprimez votre compte il sera impossible de le récupérer !',
    'Open in a New Window': 'Ouvrir dans une nouvelle fenêtre',
    'Open Revision': 'Ouvrir',
    'Operating Systems': "Système d'exploitation",
    'Organization': 'Nom de votre société',
    'Orientation': 'Orientation',
    'Out of Service': 'Hors service',
    'Overview': 'Aperçu',
    'Owner': 'Propriétaire du compte',
    'Pages Per Visit': 'Pages par visite',
    'Pages': 'Pages',
    'Pageviews': 'Pages vues',
    'Paragraph': 'Paragraphe',
    'Password': 'Mot de passe',
    'Passwords must be at least eight characters long.': "Le mot de passe doit être composé d'au moins huit caractères.",
    'Payment History': 'Historique des paiements',
    'Payment Source': 'Moyen de paiement',
    'Permissions': 'Autorisations',
    'Personal Access Token': 'Jeton d\'accès personnel',
    'Personal': 'Personnel',
    'Photo of {name}': 'Photo de {name}',
    'Pin to Top': 'Epingler',
    'Please check your email for further instructions.': 'Un lien de réinitialisation vient de vous être envoyé par e-mail.',
    'Please choose a password for your new account.': 'Choisissez un mot de passe pour votre compte.',
    'Please contact your administrator for details.': 'Contactez votre administrateur pour plus de détails.',
    'Please correct the highlighted errors.': 'Veuillez corriger les erreurs surlignées.',
    'Please enter the recovery code you were given when you enabled two-factor authentication.': 'Veuillez saisir le code de récupération qui vous a été fourni lorsque vous avez activé l\'authentification à deux facteurs.',
    'Please enter your password to continue.': 'Veuillez saisir votre mot de passe pour continuer.',
    'Please open your authentication app and enter the two-factor authentication code here.': 'Veuillez ouvrir votre application d\'authentification et saisir ici le code d\'authentification à deux facteurs.',
    'Please provide details about the issue.': 'Veuillez préciser votre demande.',
    'Please review the {guidelines}. Non-commercial websites are verified to prevent abuse.': 'Veuillez consulter les {guidelines}. Les sites Web non commerciaux sont vérifiés pour éviter les abus.',
    'Please scan this code with your authentication app. If you don\'t have one, try one of these.': 'Veuillez scanner ce code avec votre application d\'authentification. Si vous n\'en avez pas, essayez-en un.',
    'Please store this recovery code in a secure place such as a password manager. If you lose your device, you will need it to access your account.': 'Please store this recovery code in a secure place such as a password manager. If you lose your device, you will need it to access your account.',
    'Please upgrade your account to unlock this feature.': 'Souscrivez à un abonnement supérieur pour débloquer cette fonctionnalité.',
    'Port': 'Port',
    'Portrait': 'Format portrait',
    'Position Your Photo': 'Cadrer votre photo',
    'Preformatted Text': 'Texte brut',
    'Prevent Search Engines From Indexing This Page': "Empêcher les moteurs de recherche d'indexer cette page.",
    'Prioritize My Request': 'Traiter ma question en priorité',
    'Protocol': 'Protocole',
    'Provide a short and descriptive name for the anchor.': 'Donnez un nom à cette ancre.',
    'Provide as much detail as necessary. For example, how can the problem be replicated? Are you receiving an error message?': "Merci de fournir autant de détails que possible. Par exemple, comment reproduire le problème ou si vous avez vu apparaître un message d'erreur.",
    'Publish': 'Enregistrer & Publier',
    'Published by {name}': 'Publié par {name}',
    'Published Changes': 'Modifications publiées',
    'Publishing {processed} of {total} Pages': "Publication de 0 page | Publication d'1 page | Publication de la page {processed} sur {total}",
    'Receive an email when others publish changes to this site.': 'Recevoir un e-mail à chaque modification du site par un autre utilisateur.',
    'Recent Activity': 'Activité récente',
    'Recover My Account': 'Récupérer mon compte',
    'Recover My Password': 'Réinitialiser',
    'Recovery Code': 'Code de récupération',
    'Redo': 'Rétablir',
    'Referring URLs': "URLs d'origine",
    'Refresh': 'Actualiser',
    'Regenerate': 'Régénérer',
    'Region': 'Région',
    'Remember This Device': 'Se souvenir de cet appareil',
    'Remove Formatting': 'Supprimer le mise en forme',
    'Remove Link': 'Supprimer le lien',
    'Remove': 'Supprimer',
    'Rename': 'Renommer',
    'Repeat': 'Répéter',
    'Require for all users': 'Exiger pour tous les utilisateurs',
    'Require Two-factor Authentication': 'Exiger une authentification à deux facteurs',
    'Reset Demo': 'Réinitialiser',
    'Reset My Password': 'Enregistrer',
    'Reset Your Password': 'Réinitialisez votre mot de passe',
    'Resources': 'Ressources',
    'Revoke': 'Retirer',
    'Rotate': 'Faire pivoter',
    'Row': 'Ligne',
    'Save Changes': 'Enregistrer',
    'Save Draft & Upgrade': 'Enregistrer',
    'Save Draft': 'Enregistrer le brouillon',
    'Saved a Draft': 'A enregistré un brouillon',
    'Saved by {name}': 'Enregistré par {name}',
    'Saving...': 'Enregistrement…',
    'Screen Colors': "Couleurs d'écran",
    'Screen Resolutions': "Résolution d'écran",
    'Search hundreds of thousands of free, high-quality photos.': 'Rechercher parmi des milliers de photos gratuites et de très haute qualité.',
    'Search Pages': 'Rechercher une page',
    'Search Sites': 'Rechercher un site',
    'Search Unsplash': 'Rechercher sur Unsplash',
    'Search Users': 'Rechercher un utilisateur',
    'Secret Access Key': 'Secret Access Key',
    'Section Break': 'Saut de section',
    'Select a logo to use on dark backgrounds.': 'Choisissez un logo à utiliser sur un fond sombre.',
    'Select a logo to use on light backgrounds.': 'Choisissez un logo à utiliser sur un fond clair.',
    'Select a profile to enable the analytics dashboard for this site.': "Sélectionné un profil pour activer les mesures d'audience pour ce site.",
    'Select an image to use as the favicon.': 'Choisissez une image à utiliser en tant que favicône.',
    'Select the folder that contains your homepage.': "Sélectionnez le dossier qui contient la page d'accueil.",
    'Select the folder where uploaded files will be stored.': 'Sélectionnez le dossier  dans lequel les fichiers seront uploadés.',
    'Select': 'Sélectionner',
    'Selected Pages': 'Sélection',
    'Server Error': 'Erreur serveur',
    'Services': 'Services',
    'Settings': 'Paramètres',
    'Shown in browser tabs and search results.': 'Visible dans les onglets des navigateurs et les résultats de recherche.',
    'Shown under the title in search results.': 'Visible également dans les résultats des moteurs de recherche.',
    'Shown when the page is shared in third-party apps.': "Visible lors d'un partage de la page sur des sites tiers.",
    'Shown when users hover over the link.': "Apparaît lorsque l'on passe sur le lien.",
    'Sites': 'Sites',
    'Size': 'Taille',
    'Small Print': 'Petits caractères',
    'Sorry, but the editor could not be initialized. Please reload the page and try again.': "Désolé, une erreur est apparue à l'initialisation de l'éditeur. Rechargez la page et essayez de nouveau s'il vous plait.",
    'Source': 'Code source',
    'Split Cells': 'Séparer les cellules',
    'Squarish': 'Format carré',
    'Start Date': 'Date de début',
    'Start typing to add a site...': "Saisissez le nom d'un site…",
    'Strikethrough': 'Barré',
    'Submit Request': 'Envoyer',
    'Submit': 'Envoyer',
    'Subscript': 'Indice',
    'Superscript': 'Exposant',
    'Support URL': 'Adresse du support',
    'Support': 'Assistance',
    'Table': 'Tableau',
    'Technical': 'Technique',
    'Template': 'Template',
    'Test Connection': 'Tester la connexion',
    'Thanks for confirming your {appName} account!': "Merci d'avoir confirmé votre compte {appName}!",
    'Thanks for using {appName}!': "Merci d'utiliser {appName}!",
    'The analytics dashboard has not been enabled for this site.': "Le tableau de bord de mesure de l'audience n'a pas été activé pour ce site.",
    'The demo has been reset.': 'Le site de démo a bien été réinitialisé.',
    'The link you followed has expired.': 'Ce lien a expiré.',
    'The page will be created inside this folder on your server.': 'La page sera créée dans ce dossier sur votre serveur.',
    'The page you requested could not be found.': 'Page introuvable.',
    'The selected path is outside of the site\'s home folder.': "Le chemin selectionné est en dehors du dossier de la page d'accueil.",
    'The token you entered is not valid.': 'Le jeton que vous avez entré n\'est pas valide.',
    'This adds an extra layer of security to your account by requiring access to a known device (such as a smartphone) before logging into your account.': 'Cela ajoute une couche supplémentaire de sécurité à votre compte en exigeant l\'accès à un appareil connu (tel qu\'un smartphone) avant de vous connecter à votre compte.',
    'This appears to be a commercial website, but you\'re on a personal plan. Please upgrade your account to publish this website.': "Ce site semble être un site commercial, ce que ne permet la formule gratuite. Veuillez souscrire à un abonnement payant pour publier ce site s'il vous plait.",
    'This cannot be changed when you\'re logged in to your custom domain.': 'Vous ne pouvez pas être connecté à votre domaine personnalisé pour effectuer cette modification.',
    'This domain is already in use.': 'Ce domaine est déjà utilisé.',
    'This domain is no longer active.': "Ce domaine n'est plus actif.",
    'This email address is already in use.': 'Adresse e-mail déjà utilisée.',
    'This email address is not registered.': 'Adresse e-mail inconnue.',
    'This information will appear on all of your invoices.': 'Ces informations figureront sur toutes vos factures.',
    'This is used to reference the page in the CMS.': 'Ce nom permet de référencer la page dans le CMS.',
    'This is where you and your clients will go to access the CMS.': "Il s'agira de l'adresse de connexion au CMS pour vos utilisateurs et vous.",
    'This is your API token. Protect it like you would a password. If your token is ever compromised, you can regenerate it using the button above.': 'Ceci est votre jeton API. Protégez-le comme vous le feriez avec un mot de passe. Si votre jeton est compromis, vous pouvez le régénérer à l\'aide du bouton ci-dessus.',
    'This page doesn\'t have any content regions.': 'Cette page ne contient pas de zone modifiable.',
    'This request cannot be completed because the site is on lockdown.': 'Votre demande ne peut pas aboutir car le site est verrouillé.',
    'This site has reached the maximum number of templates allowed.': 'Ce site a atteint la limite de templates autorisés.',
    'This Site is on Lockdown': 'Ce site est verrouillé',
    'This type of file is not supported.': "Ce type de fichier n'est pas autorisé.",
    'This user is an administrator so they have access to all sites. You need to disable administrative privileges if you want to limit their access.': 'Cet utilisateur est un administrateur. Il a donc accès à tous les sites.',
    'This user will have access to the following sites.': 'Cet utilisateur aura accès aux sites suivants :',
    'This will be displayed instead of "Surreal CMS" throughout the app.': 'Ce nom s\'affichera à la place de "Surreal CMS".',
    'This will be shown in search engine results, browser tabs, bookmarks, etc.': 'Cela sera visible dans les résultats des moteurs de recherche, dans les onglets des navigateurs, etc.',
    'This will cause existing links to this file to stop working.': 'Les liens existants vers ce fichier cesseront de fonctionner.',
    'This will delete the site from the CMS, but not from your web server.': 'Le site restera consultable sur Internet mais ne pourra plus être modifié ici.',
    'This will delete the user and revoke all access to the CMS.': "L'utilisateur ainsi que toutes ses autorisations seront supprimés.",
    'This will delete your account permanently.': 'Votre compte sera définitivement supprimé.',
    'This will destroy your token and disable API access. All applications that use this token will stop working.': 'Cela détruira votre jeton et désactivera l\'accès à l\'API. Toutes les applications qui utilisent ce jeton cesseront de fonctionner.',
    'This will permanently delete the selected blocks.': 'Les blocs sélectionnés seront définitivement supprimés.',
    'This will permanently delete the selected pages from your web server.': 'Les pages sélectionnées seront définitivement supprimées et donc plus visibles sur le site.',
    'This will permanently delete the selected templates.': 'Les templates sélectionnés seront définitivement supprimés.',
    'This will remove the selected pages from the CMS, but not from your web server.': 'Les pages sélectionnées resteront visibles sur Internet mais ne seront plus modifiables ici.',
    'This will require all users to enable two-factor authentication. Every user will need to use an app such as Google Authenticator before they can access their account.': 'Cela obligera tous les utilisateurs à activer l\'authentification à deux facteurs. Chaque utilisateur devra utiliser une application telle que Google Authenticator avant de pouvoir accéder à son compte.',
    'Tile': 'Tuile',
    'Title': 'Titre',
    'To change your subscription, please visit the {billing} section.': 'Pour changer votre souscription veuillez vous rendre à la rubrique {billing}.',
    'To enable two-factor authentication for just your account, visit the profile page.': 'Pour activer l\'authentification à deux facteurs uniquement pour votre compte, visitez la page de profil.',
    'to': 'à',
    'Today': "Aujourd'hui",
    'Toggle Full Screen Mode': 'Mode plein écran',
    'Toggle Header Cells': 'En-tête',
    'Traffic Sources': 'Origines',
    'Traffic': 'Traffic',
    'Two-factor Authentication': 'Authentification à deux facteurs',
    'Type a few sentences about this user.': "Ecrivez quelques mots à propos de l'utilisateur.",
    'Type a few sentences about yourself.': 'Ecrivez quelques mots à propos de vous.',
    'Type of Website': 'Type de site Web',
    'Unable to authenticate with your server.': "L'authentification avec votre serveur a échoué.",
    'Unable to connect to your website.': 'La connexion avec votre site a échoué.',
    'Unable to create the directory on your server.': 'La création du dossier sur votre serveur a échoué.',
    'Unable to delete the file from your server.': 'La suppression du fichier sur votre serveur a échoué.',
    'Unable to download the file from your server.': 'Le téléchargement du fichier a échoué.',
    'Unable to list the directory on your server.': 'Impossible de lister les répertoires sur votre serveur.',
    'Unable to move the file on your server.': 'Impossible de déplacer le fichier sur votre serveur.',
    'Unable to upload the file to your server.': "L'upload du fichier sur le serveur a échoué.",
    'Undo': 'Annuler',
    'Unsaved Changes': 'Modifications non-enregistrées',
    'Unsupported Element': 'Elément non supporté',
    'Update Anchor': 'Enregistrer',
    'Update Background': 'Enregistrer',
    'Update Code Block': 'Enregistrer',
    'Update Gallery': 'Enregistrer',
    'Update Image': 'Enregistrer',
    'Update Link': 'Enregistrer',
    'Update Metadata': 'Enregistrer',
    'Update Payment Info': 'Enregistrer',
    'Update Video': 'Enregistrer',
    'Upgrade My Account': 'Mettre à niveau',
    'Upgrade Required': 'Mise à niveau nécessaire',
    'Upgrade to unlock priority support, commercial sites, and more features!': 'Souscrivez à un abonnement payant pour débloquer plus de fonctionnalités !',
    'Upgrade': 'Upgrade',
    'Upload Folder': "Dossier d'upload",
    'Upload': 'Uploader',
    'Uploads': 'Uploads',
    'URL': 'URL',
    'Username': 'Identifiant',
    'Users': 'Utilisateurs',
    'Video': 'Vidéo',
    'View Info': "Infos sur l'image",
    'View Invoice': 'Voir la facture',
    'View on Unsplash': 'Voir sur Unsplash',
    'View Webpage': 'Voir la page sur le site',
    'View Website': 'Voir le site',
    'Visit Documentation': 'Visiter la documentation',
    'Visitors': 'Visiteurs',
    'Visits': 'Visites',
    'Warning': 'Alerte',
    'We can save your changes as a draft so you can publish them after you\'ve upgraded.': 'Vos modifications peuvent être enregistrées comme brouillon pour que vous puissiez les publier une fois la mise à niveau de votre abonnement effectuée.',
    'We hope you enjoy using {appName}': "Nous espérons que vous apprécierez l'utilisation de {appName}!",
    'We provide a demo site for you to experiment with. If you\'ve modified it or removed it, you can reset it here.': 'Nous fournissons un site de démonstration pour que vous puissiez faire vos tests et découvrir le service. En cas de besoin vous pouvez le réinitialiser en cliquant ci-dessous.',
    'We were unable to fetch data from your analytics provider.': "Nous n'avons pas réussi à récupérer les données de votre fournisseur de mesure d'audience.",
    'Website Classification Guidelines': 'Directives de classification des sites Web',
    'Welcome to {appName}': "Bienvenue sur l'éditeur de site de {appName}",
    'Welcome!': 'Bienvenue !',
    'What do you need help with?': "Quel est l'objet de votre demande d'assistance ?",
    'When enabled, users won\'t be able to publish changes to the site.': "Lorsqu'un site est verrouillé les utilisateurs ne peuvent plus publier de modification.",
    'Which site does this involve?': 'Quels sont les sites concernés ?',
    'White-label settings will be applied when you login in to your custom domain.': "Les utilisateurs se connectant à cette adresse verront l'interface personnalisée selon les paramètres définis ci-dessous.",
    'White-label Settings': 'Paramètres de la marque-blanche',
    'Yesterday': 'Hier',
    'You must enable two-factor authentication for your own account before requiring it for everyone.': 'Vous devez activer l\'authentification à deux facteurs pour votre propre compte avant de l\'exiger pour tout le monde.',
    'You recently requested to reset the password for your {appName} account.': 'Vous avez récemment demandé la réinitialisation du mot de passe de votre compte {appName}.',
    'Your administrator requires two-factor authentication for all accounts.': 'Votre administrateur requiert une authentification à deux facteurs pour tous les comptes.',
    'Your analytics provider says you do not have permission to access this property.': "Votre fournisseur d'analyse d'audience refuse cet accès.",
    'Your changes have been saved.': 'Modifications enregistrées.',
    'Your changes haven\'t been saved. Are you sure you want to continue?': "Les modifications n'ont pas été enregistrées. Êtes-vous sûr de vouloir continuer ?",
    'Your favorites will appear in the sidebar for quick access.': 'Les favoris apparaitront dans la barre latérale pour un accès rapide.',
    'Your password has been updated.': 'Mot de passe mis à jour.',
    'Your password is incorrect.': 'Mot de passe incorrect.',
    'Your request has been received. We\'ll be in touch soon!': 'Votre question a bien été envoyée. Nous reviendrons vers vous très rapidement !',
    'Your syntax highlighter will use this to identify the programming language.': 'Précisez le langage de programmation.',
    'Zoom': 'Zoomer',

    // Import the corresponding Element UI locale
    ...elementLocale
  },

  // Date formats
  dateTimeFormats: {
    'short': {
      'year': 'numeric',
      'month': 'numeric',
      'day': 'numeric'
    },
    'medium': {
      'year': 'numeric',
      'month': 'numeric',
      'day': 'numeric',
      'hour': 'numeric',
      'minute': 'numeric'
    },
    'long': {
      'year': 'numeric',
      'month': 'numeric',
      'day': 'numeric',
      'weekday': 'short',
      'hour': 'numeric',
      'minute': 'numeric'
    }
  },

  // Number formats
  numberFormats: {
    'currency': {
      'style': 'currency',
      'currency': 'USD'
    },
    'currencyInteger': {
      'style': 'currency',
      'currency': 'USD',
      'minimumFractionDigits': 0,
      'maximumFractionDigits': 0
    },
    'decimal': {
      'style': 'decimal',
      'useGrouping': true
    },
    'integer': {
      'style': 'decimal',
      'useGrouping': true,
      'maximumFractionDigits': 0
    }
  }
};
